
import {filter, combineLatest} from 'rxjs/operators';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Component, ViewEncapsulation, OnInit,  } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AppcuesOnboardingObserver } from '@toro/common/shared/services/appcues/ng/observer.service';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { HomeStatus } from '@toro/common/shared/enum/home-status.enum';
import { RolesUser } from '@toro/common/shared/enum/roles-user.enum';
import { User } from '@toro/common/shared/models/User';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { BackendToFrontendParserService } from '@toro/common/shared/services/parser/backend-to-frontend-parser.service';
import { SuitabilityState } from '@toro/common/shared/state-management/suitability/suitability.reducer';
import { DocumentTypeUserEnum } from '@toro/common/shared/enum/document-type-user.enum';
import { SuitabilityProfilesEnum } from '@toro/common/shared/enum/suitability/suitability-profiles.enum';
import { RegistrationStatus } from '@toro/common/shared/enum/registration-status.enum';
import { StorageService } from '@toro/common/shared/services/storage.service';

@AutoUnsubscribe()
@Component({
  selector: 'home-logged-main',
  templateUrl: './home-logged-main.component.html',
  styleUrls: ['./home-logged-main.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [AppcuesOnboardingObserver, DatePipe]
})

export class HomeLoggedMainComponent extends DisposableSafelly implements OnInit {
    
    public user: User;
    public homeRole: HomeStatus;
    public userRoles = RolesUser;
    public homeStatus = HomeStatus;
    public isNegativeOnD0: boolean;
    public totalNetEquity: number;
    public showModalIntegrationPi = false;
    public isShowValue = true;
    public userCblc: string;

    constructor(
        private store: Store<AppState>,
        private backendToFrontendParserService: BackendToFrontendParserService,
    ) {
        super();

    }

    public ngOnInit() {
        this.store
        .select(({ userProfile, suitability }) => ({ user: userProfile.user, suitability })).pipe(
        combineLatest(
          this.store.select(({ finance }) => finance),
          this.store.select(({ authentication }) => authentication.currentUser),
        ),
        filter(([{ user: { profile } }, { finance }, currentUser]) =>
          !!profile && !!finance && !!currentUser
        ),)
        .subscribe(([{ user, suitability }, { finance, consolidatePosition: consolidated }, { cblc }]) => {
          this.user = user;
          this.userCblc = cblc;
          this.isNegativeOnD0 = finance.availableOnAccountD0 < 0;
          this.totalNetEquity = consolidated.totalNetEquity;
          this.defineHomeRole(this.user, suitability);
        });

        const dateMax = new Date(2147483647 * 1000);

        StorageService.setCookie('hubUserStatus', this.homeRole.toString(), dateMax);
    }

    public ngAfterViewInit() {}

    /**
     * Determina o cenário de home do usuário
     *
     * @param user
     */
    public defineHomeRole(
        { profile: customerStatus, registrationStatus, documents }: Partial<User> & { documents?: any[] },
        suitability: SuitabilityState,
      ) {
        const registrationStatusEnum = this.backendToFrontendParserService.parseRegistrationStatus(registrationStatus);
    
        switch (customerStatus as RolesUser) {
    
          // Cenário de usuários ativos
          case RolesUser.Activated: {
            if (this.isNegativeOnD0 || this.totalNetEquity < 0) {
              this.homeRole = this.homeStatus.ActivatedNegative;
            }
            else {
              this.homeRole = HomeStatus.Activated;
            }
            return this.homeRole;
          }
    
          // Cenários de usuários registrados
          case RolesUser.Registered: {
            return this.homeRole = HomeStatus.RegisteredWithoutMoney;
          }
    
          // Cenário de usuários identificados
          case RolesUser.Identified: {
            switch (registrationStatusEnum) {
              case RegistrationStatus.CreatingAccount: {
                return this.homeRole = HomeStatus.UserIdentified;
              }
              case RegistrationStatus.LoginWithoutAccount: {
                return this.homeRole = HomeStatus.UserNotFilling;
              }
    
              case RegistrationStatus.RegisteredUser: {
                return this.homeRole = HomeStatus.RegisteredWithoutMoney;
              }
    
              default: {
                const hasDocuments = documents && documents.some(({ documentTypeGUID }) => documentTypeGUID === DocumentTypeUserEnum.CE);
                const hasSuitability = suitability.profile && suitability.profile.profile !== SuitabilityProfilesEnum.NoProfile;
                if (registrationStatusEnum === RegistrationStatus.ExternalIssues) {
                  return this.homeRole = hasDocuments ? HomeStatus.RegisteredExternalIssuer : HomeStatus.RegisteredSendDocs;
                } else {
                  const statusBySuitabilityAndDocuments = hasSuitability ? HomeStatus.RegisteredDocsSended : HomeStatus.RegisteredDocsSendedWithoutSuitability;
                  return this.homeRole = hasDocuments ? statusBySuitabilityAndDocuments : HomeStatus.RegisteredWithoutDocs;
                }
              }
            }
          }
    
          default: {
            return this.homeRole = HomeStatus.UserNotFilling;
          }
    
        }
      }

    public onOpenModoalIntegrationPi(event: boolean) {
        this.showModalIntegrationPi = event;
    }

    public changeShow(event: boolean) {
        this.isShowValue = event;
    }

}
